export const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY || ''
